export default __webpack_public_path__ + "static/media/madReaders.e8ae46e2.jpg";